import ResponseMenu from "./ResponseMenu";

export default ResponseMenu;
